import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RequestStatus} from '../../utils/Enums';
import {apiClient} from '../../utils/ApiClient';
import {InvoiceHistoryEntry} from '../../models/InvoiceHistory';

interface InvoiceHistoryState {
    entries: InvoiceHistoryEntry[];
    status: RequestStatus;
    currentPage: number;
    totalPages: number;
    total: number;
    error: string | null;
}

interface InvoiceHistoryFilters {
    search: string;
    sender: string;
    dateFrom: string;
    dateTo: string;
    page: number;
    perPage: number;
}

const initialState: InvoiceHistoryState = {
    entries: [],
    status: RequestStatus.Idle,
    currentPage: 1,
    totalPages: 1,
    total: 0,
    error: null,
};

export const getInvoiceHistory = createAsyncThunk(
    'invoiceHistory/getInvoiceHistory',
    async (filters: InvoiceHistoryFilters) => {
        const params = new URLSearchParams();
        params.set('page', filters.page.toString());
        params.set('perPage', filters.perPage.toString());

        if (filters.search) params.set('search', filters.search);
        if (filters.sender) params.set('sender', filters.sender);
        if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
        if (filters.dateTo) params.set('dateTo', filters.dateTo);

        const response = await apiClient.get(`invoice-history?${params.toString()}`);
        return response.data;
    }
);

const invoiceHistorySlice = createSlice({
    name: 'invoiceHistory',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInvoiceHistory.pending, (state) => {
                state.status = RequestStatus.Loading;
                state.error = null;
            })
            .addCase(getInvoiceHistory.fulfilled, (state, action) => {
                state.status = RequestStatus.Success;
                state.entries = action.payload.data;
                state.currentPage = action.payload.current_page;
                state.totalPages = action.payload.last_page;
                state.total = action.payload.total;
            })
            .addCase(getInvoiceHistory.rejected, (state, action) => {
                state.status = RequestStatus.Failed;
                state.error = action.error.message || 'Arvete ajaloo laadimine ebaõnnestus.';
            });
    },
});

export default invoiceHistorySlice.reducer;
